import { useEffect, useState } from "react";
import { base64ToBlob } from "file64";
import { detailQuestImg } from "../../config/apiSPA";

function ImageHandler({ url }) {
  const [blob, setBlob] = useState();
  async function toBlob(base64) {
    const blob = await base64ToBlob(base64);
    setBlob(URL.createObjectURL(blob));
  }
  useEffect(() => {
    detailQuestImg(url).then((res) => toBlob(res.img));
  }, [url]);

  return (
    <>
      <img src={blob} className="img-thumbnail" alt="QImage"></img>
    </>
  );
}
export default ImageHandler;
